import http from "../config/http-configs";
import {configForm} from "@/api/config/http-configs";


//员工
export const addUsualVisitor = (visitorCode) => {
    return http.get(`/mobile/usual/visitor/add/${visitorCode}`)
}

export const updateUsualVisitor = (visitorCode) => {
    return http.get(`/mobile/usual/visitor/update/${visitorCode}`)
}

export const deleteUsualVisitor = (visitorCodes) => {
    const url = "/mobile/usual/visitor/delete?visitorCodes=" + visitorCodes;
    return http.post(url, null, configForm)
}

export const getUsualVisitor = () => {
    return http.get('/mobile/usual/visitor/list')
}
